import OfferEvent from '@models/offer/OfferEvent';

/**
 * Temporary functionality for meta whitelist
 */
export function setLiteMode(): void {
    localStorage.setItem('liteMode', 'true');
}

export function getLiteMode(): string {
    return localStorage.getItem('liteMode') || '';
}

const metaHiddenSports = new Set([
    75, // esport soccer
    39, // league of legends
    55, // counter strike
    54, // dota 2
    70, // esport basketball
    61, // call of duty
    88, // king of glory
    153, // valorant
]);

export function omitSports(sportNodes: any[]): any[] {
    return sportNodes.filter((node) => !metaHiddenSports.has(node.id));
}

export function omitEvents(events: OfferEvent[]): OfferEvent[] {
    return events.filter((event) => !metaHiddenSports.has(event.sportId));
}
